// components/ThemeProvider.tsx
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const settings = useSelector((state: RootState) => state.themeSettings);

    useEffect(() => {
        const root = document.documentElement;
        if (settings.primaryColor) {
            root.style.setProperty("--primary", settings.primaryColor);
        }
        if (settings.secondaryColor) {
            root.style.setProperty("--secondary", settings.secondaryColor);
        }
        if (settings.textPrimaryColor) {
            root.style.setProperty("--text-primary", settings.textPrimaryColor);
        }
        if (settings.textSecondaryColor) {
            root.style.setProperty("--text-secondary", settings.textSecondaryColor);
        }
        if (settings.backgroundPrimaryColor) {
            root.style.setProperty("--bg-page", settings.backgroundPrimaryColor);
        }
    }, [settings]);

    return <>{children}</>;
};
